/* tslint:disable */
/* eslint-disable */
/**
 * Jen API
 * Jen RESTful APIs, designed to provide easy access to our latest music generation models.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateMusicV2Dto
 */
export interface GenerateMusicV2Dto {
    /**
     * 
     * @type {string}
     * @memberof GenerateMusicV2Dto
     */
    prompt: string;
    /**
     * <= 180
     * @type {number}
     * @memberof GenerateMusicV2Dto
     */
    duration: number;
    /**
     * 
     * @type {string}
     * @memberof GenerateMusicV2Dto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateMusicV2Dto
     */
    trackName?: string;
    /**
     * 
     * @type {number}
     * @memberof GenerateMusicV2Dto
     */
    folderId?: number;
    /**
     * 
     * @type {string}
     * @memberof GenerateMusicV2Dto
     */
    format?: string;
    /**
     * 
     * @type {number}
     * @memberof GenerateMusicV2Dto
     */
    styleFilterId?: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateMusicV2Dto
     */
    filterWeight?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GenerateMusicV2Dto
     */
    assist?: boolean;
    /**
     * length of fade out in the end
     * @type {number}
     * @memberof GenerateMusicV2Dto
     */
    fadeOutLength?: number;
    /**
     * number of tracks
     * @type {number}
     * @memberof GenerateMusicV2Dto
     */
    tracksNum?: number;
}

/**
 * Check if a given object implements the GenerateMusicV2Dto interface.
 */
export function instanceOfGenerateMusicV2Dto(value: object): value is GenerateMusicV2Dto {
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    return true;
}

export function GenerateMusicV2DtoFromJSON(json: any): GenerateMusicV2Dto {
    return GenerateMusicV2DtoFromJSONTyped(json, false);
}

export function GenerateMusicV2DtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateMusicV2Dto {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
        'duration': json['duration'],
        'model': json['model'],
        'trackName': json['trackName'] == null ? undefined : json['trackName'],
        'folderId': json['folderId'] == null ? undefined : json['folderId'],
        'format': json['format'] == null ? undefined : json['format'],
        'styleFilterId': json['styleFilterId'] == null ? undefined : json['styleFilterId'],
        'filterWeight': json['filterWeight'] == null ? undefined : json['filterWeight'],
        'assist': json['assist'] == null ? undefined : json['assist'],
        'fadeOutLength': json['fadeOutLength'] == null ? undefined : json['fadeOutLength'],
        'tracksNum': json['tracksNum'] == null ? undefined : json['tracksNum'],
    };
}

export function GenerateMusicV2DtoToJSON(json: any): GenerateMusicV2Dto {
    return GenerateMusicV2DtoToJSONTyped(json, false);
}

export function GenerateMusicV2DtoToJSONTyped(value?: GenerateMusicV2Dto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prompt': value['prompt'],
        'duration': value['duration'],
        'model': value['model'],
        'trackName': value['trackName'],
        'folderId': value['folderId'],
        'format': value['format'],
        'styleFilterId': value['styleFilterId'],
        'filterWeight': value['filterWeight'],
        'assist': value['assist'],
        'fadeOutLength': value['fadeOutLength'],
        'tracksNum': value['tracksNum'],
    };
}

